<template>
  <div :class="['anno', this.maskShow ? '' : 'row']">
    <div v-wechat-title="$route.meta.title"></div>
    <div class="container" :class="langType">
      <div class="topTitle">
        <img class="icon1" src="../assets/icon1.png" />
        <div class="inviteView">
          <div class="topView">
            <img :src="headImg" class="userImg" @click="toRoom('224803')" />
            <p class="inviteInfo">
              <span v-if="langType === 'ar'">يدعوك</span> <span v-else>Invite</span>
              <span
                class="nickNameView"
                >{{ this.nickName }}</span
              >
              <span v-if="langType === 'ar'"
                >للدخول إلى الغرفة للدردشة والاستمتاع سوياً</span
              ><span v-else>To enter the room chat and have fun together</span>
            </p>
          </div>
          <div class="bottomView">
            <div>
              <p>456893</p>
              <p>Invite code</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="banner">
      </div> -->
      <div class="contents">
        <img
          :src="
            mySwiper.realIndex == 1
              ? emoji2
              : mySwiper.realIndex == 2
              ? emoji3
              : mySwiper.realIndex == 3
              ? emoji4
              : emoji1
          "
          class="emogi_01"
        />
        <img
          v-show="mySwiper.realIndex == 0"
          src="../assets/share_emoji_04.png"
          class="emogi_02"
        />
        <img
          v-show="mySwiper.realIndex == 3"
          src="../assets/share_emoji_05.png"
          class="emogi_03"
        />
        <div class="contentView">
          <div class="swiper-container" ref="Myswper">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <div class="zong_zi_1"></div>
              </div>
              <div class="swiper-slide">
                <div class="zong_zi_2"></div>
              </div>
              <div class="swiper-slide">
                <div class="zong_zi_3"></div>
              </div>
              <div class="swiper-slide">
                <div class="zong_zi_4"></div>
              </div>
              <!-- <div class="swiper-slide">
                <div class="zong_zi_1" id="zong_zi_1">
                </div>
              </div>

              <div class="swiper-slide">
                <div class="zong_zi_1" id="zong_zi_1">
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="lineSwiper">
          <p :class="['p1', mySwiper.realIndex == 0 ? 'pSelect' : '']"></p>
          <p :class="['p2', mySwiper.realIndex == 1 ? 'pSelect' : '']"></p>
          <p :class="['p2', mySwiper.realIndex == 2 ? 'pSelect' : '']"></p>
          <p :class="['p3', mySwiper.realIndex == 3 ? 'pSelect' : '']"></p>
        </div>
      </div>
    </div>
    <div class="tips" :class="{ on: tips != '' }" v-if="tips != ''">
      <p>{{ tips }}</p>
    </div>
    <div :class="['footerView', toBottom == true ? 'footerView1' : '']" ref="bottomView">
      <!-- <img class="clickBtn" @click="openApp" src="../assets/clickBtn.png" /> -->
      <img
        v-if="langType === 'ar'"
        class="clickBtn"
        id="downloadButton"
        src="../assets/clickBtn-ar.png"
      />
      <img v-else class="clickBtn" id="downloadButton" src="../assets/clickBtn-en.png" />
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.min.css'
import Header from './Header'
import {
  Params,
  getSessionId,
  getUid,
  browser,
  setSessionId,
  getQueryString
} from '../util/util.js'
import emoji1 from '../assets/share_emoji_06.png'
import emoji2 from '../assets/share_emoji_01.png'
import emoji3 from '../assets/share_emoji_02.png'
import emoji4 from '../assets/share_emoji_03.png'
import loadImg from '../assets/load_image.png'
import Qs from 'qs'
let Base64 = require('js-base64').Base64
export default {
  name: 'tips',
  data () {
    return {
      mySwiper: {},
      giftName: this.$store.state.giftName,
      giftImgUrl: this.$store.state.giftImgUrl,
      tips: '',
      limitTime: this.$store.state.limitTime,
      maskShow: false,
      backToTop: false,
      list: [],
      myUid: 0,
      sessionid: getSessionId(),
      /* zongzi */
      marqueeList: [],
      animate: false,
      showMask: false,
      zongziMap: [],
      materialMap: [],
      rewordList: [],
      toSignRef: 'wevenus://user/sign', // 签到
      toVocalRef: 'wevenus://common/main?tab1=ccp&tab2=match', // 语音配/颜值配
      toMessageRef: 'wevenus://common/main?tab1=message&tab2=friend', // 接收匹配请求
      toNewRef: 'wevenus://common/main?tab1=bbs&tab2=new', // 帖子页
      toRechargeRef: 'wevenus://user/account', // 充值
      toGameRef: 'wevenus://room/gameList', // 游戏
      toRoomRef: 'wevenus://common/main?tab1=room&tab2=recommend', // 房间在线
      toMoveRef: 'wevenus://room/movieList', // 看电影
      status_zong1: '',
      status_zong2: '',
      status_zong3: '',
      status_zong4: '',
      status_zong5: '',
      emoji1: emoji1,
      emoji2: emoji2,
      emoji3: emoji3,
      emoji4: emoji4,
      toBottom: false,
      headImg: loadImg,
      nickName: 'XXX',
      langType: 'ar'
    }
  },
  computed: {},
  mounted () {
    this.mySwiper = new Swiper('.swiper-container', {
      autoplay: 3000,
      // speed:300,
      direction: 'horizontal',
      slidesPerView: 'auto',
      centeredSlides: true,
      // spaceBetween: 24,
      observer: true,
      observeParents: true,
      loop: true,
      onClick: function (swiper) {
        // alert('你点了Swiper');
        // alert(mySwiper.realIndex);     //当前索引
      },
      onSlideChangeEnd: function (swiper) {
        var num = swiper.realIndex
        // console.log('当前页', num)
      }
    })
  },
  methods: {
    openApp () {
      if (browser.versions.ios) {
        // window.location.href = "com.baidu.tieba://"; //ios app协议
        // window.setTimeout(function() {
        //   window.location.href = "https://apps.apple.com/app/id1489566586"; // ios下载地址
        // }, 2000)
        window.location.href = 'https://apps.apple.com/app/id1489566586' // ios下载地址
      } else {
        // window.location.href = "mqqwpa://im/chat?chat_type=wpa&uin=479858761&version=1&src_type=web&web_src=oicqzone.com"
        // window.location.href = "com.baidu.tieba://app"; //Android app协议
        // window.location.href = "com.baidu.tieba://usercenter"; //Android app协议
        // window.setTimeout(function() {
        //   window.location.href = "https://play.google.com/store/apps/details?id=com.duiud.bobo"; // 安卓下载地址
        // }, 2000)
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.duiud.bobo' // ios下载地址
      }
    },
    weCallback: function (code, msg, requestCode) {
      // this.showTips('requestCode: '+ requestCode + 'msg: ' + msg, this)
      // if (requestCode === 1) {
      //   this.invoke()
      // }
      if (requestCode === 1) {
        let json = JSON.parse(msg)
        this.$store.commit('setLoginAccount', json)
        if (this.$store.state.userInfo.token) {
          // setSessionId(token.split(',')[0])
          setSessionId(this.$store.state.userInfo.token)
        }
        // this.invoke()
      } else {
        this.$children.forEach((item) => {
          item.$emit('dispatchCallback', code, msg, requestCode)
        })
      }
    },
    showTips (tips, that) {
      that.tips = tips
      setTimeout(() => {
        that.tips = ''
      }, 1000)
    },
    scrollToTop () {
      // let scrollTop =
      //   window.pageYOffset ||
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop;
      // let browserHeight = window.outerHeight;
      // console.log('hhhh ', browserHeight)
      // if (scrollTop > browserHeight) {
      //   this.backToTop = true;
      // } else {
      //   this.backToTop = false;
      // }
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      var windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight
      var scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight
      var bottom = this.$refs.bottomView.clientHeight
      if (scrollTop + windowHeight + bottom >= scrollHeight) {
        this.toBottom = true
      } else {
        this.toBottom = false
      }
    },
    toTop () {
      let back = setInterval(() => {
        if (document.body.scrollTop || document.documentElement.scrollTop) {
          document.body.scrollTop -= 100
          document.documentElement.scrollTop -= 100
        } else {
          clearInterval(back)
        }
      })
    },
    toPage (str) {
      if (window.weBridge.openPage) {
        window.weBridge.openPage(str)
      } else {
        this.showTips('当前版本过低，请升级到最新版', this)
      }
    },
    toRoom (roomid) {
      // var str = "we://user?uid="
      // if (window.weBridge.openPage) {
      //   // window.weBridge.openPage(str + roomid)
      //   window.weBridge.goUserPage(str, roomid)
      // } else {
      //   this.showTips("当前版本过低，请升级到最新版", this)
      // }
      var str = 'bobo://chatroom?roomId='
      var to = roomid
      window.location.href = str + to
    },
    // 跳个人资料页
    toInfo (uid) {
      // var str = "we://user?uid="
      var str = 'wevenus://user/info?uid='
      if (window.weBridge.openPage) {
        window.weBridge.openPage(str + uid)
      } else {
        this.showTips('当前版本过低，请升级到最新版', this)
      }
    }
  },
  components: {
    Header
  },
  created () {
    // this.invoke()
    let sessionId = getSessionId()
    this.sessionid = sessionId
    if (
      (!this.$store.state.userInfo || !sessionId) &&
      window.weBridge &&
      window.weBridge.getLocalUser
    ) {
      window.weBridge.getLocalUser(1)
    } else {
      // this.invoke()
    }
    window.weCallback = (code, msg, requestCode) => {
      this.weCallback(code, msg, requestCode)
    }
    window.addEventListener('scroll', this.scrollToTop)
    // param String
    // base
    console.log(getQueryString('param'), "getQueryString('param')")
    let param = getQueryString('param') ? Base64.decode(getQueryString('param')) : ''
    let guide = param.split('&')
    // console.log('guide ', param)
    var guideList = {}
    guide.forEach((item, index) => {
      const title = item.split('=')[0]
      const text = item.split('=')[1]
      guideList[title] = text
    })
    console.log('传过来的用户信息 ', guideList)
    // console.log('eeet ',guideList.headImg)
    this.headImg = guideList && guideList.headImg ? guideList.headImg : this.headImg
    this.nickName = guideList && guideList.nickName ? guideList.nickName : this.nickName
    this.langType = guideList && guideList.language ? guideList.language : 'ar'
  }
}
</script>
<style scoped>
img {
  display: block;
}
.anno {
  position: relative;
  overflow: hidden;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  -khtml-user-select: none;
  user-select: none;
  -webkit-touch-callout: none;
}
.tips {
  margin-top: 2rem;
}
.topTitle {
  position: relative;
  margin-top: 2.62rem;
}
.icon1 {
  display: block;
  position: absolute;
  right: 0.5rem;
  top: -0.7rem;
  width: 2rem;
  height: 0.87rem;
}
.inviteView {
  margin: 0 auto;
  width: 3.3rem;
  /* height: 0.8rem; */
  height: auto;
  background-color: #ffffff;
  border: 0.04rem solid #ffda00;
  border-radius: 0.08rem;
  box-sizing: border-box;
}
.topView {
  display: flex;
  margin-bottom: 0.14rem;
}
.bottomView {
  display: none;
  margin: 0 auto;
  margin-bottom: 0.14rem;
  width: 2.98rem;
  height: 0.56rem;
  border-radius: 0.31rem;
  box-sizing: border-box;
  border: 1px dashed rgba(250, 204, 103, 0.9);
}
.userImg {
  width: 0.5rem;
  height: 0.5rem;
  margin-left: 0.12rem;
  margin-top: 0.08rem;
  border-radius: 50%;
}
.inviteInfo {
  margin-left: 0.1rem;
  margin-top: 0.11rem;
  width: 2.2rem;
  font-size: 0.14rem;
  color: #0e0f16;
  font-family: Avenir-Heavy;
  line-height: 0.22rem;
  text-align: left;
}
.nickNameView {
  display: inline-block;
  vertical-align: top;
  min-width: 0;
  max-width: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.container {
  /* background-color: rgb(138, 226, 226); */
  background-image: url("../assets/bg-en.png");
  background-size: 100%;
  width: 100%;
  height: 10.61rem;
  padding-top: 0.01rem;
}
.container.ar {
  /* background-color: rgb(138, 226, 226); */
  background-image: url("../assets/bg-ar.png");
  background-size: 100%;
  width: 100%;
  height: 10.61rem;
  padding-top: 0.01rem;
}
/* .banner{
  width: 100%;
  height: 3.75rem;
  background-image: url('../assets/first_figure_img.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: 100%;
} */
.notice {
  /* opacity: 0.5;
  background: #0C4608; */
  background: rgba(12, 70, 8, 0.5);
  border-radius: 0.21rem;
  border-radius: 0.21rem;
  height: 0.36rem;
  width: 3rem;
  position: relative;
  top: 3.39rem;
  left: 0.38rem;
  overflow: hidden;
}
.marquee_list {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}
.marquee_text {
  min-width: 0;
  max-width: 0.58rem;
  height: 0.36rem;
  line-height: 0.36rem;
  color: #f8e71c;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.marquee_list span {
  display: inline-block;
  vertical-align: middle;
  line-height: 0.36rem;
}
.marquee_top {
  transition: all 0.5s;
  margin-top: -0.36rem;
}
.marquee_list li {
  height: 0.36rem;
  font-size: 0.14rem;
  padding-left: 0.24rem;
  list-style: none;
  width: 2.5rem;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bagView {
  position: absolute;
  right: 0;
  top: 2.75rem;
  /* opacity: 0.6;
  background: #0C4608; */
  background: rgba(12, 70, 8, 0.6);
  border-radius: 1rem 0 0 1rem;
  width: 0.75rem;
  height: 0.34rem;
  display: flex;
  align-items: center;
}
.bagView img {
  width: 0.23rem;
  height: 0.2rem;
  margin-left: 0.11rem;
}
.bagView p {
  font-size: 0.14rem;
  color: #ffffff;
  margin-left: 0.04rem;
}
.contents {
  position: relative;
  width: 100%;
  margin-top: 0.13rem;
}
.contentView {
  /* background-image: linear-gradient(to bottom, #80DFE7, #B4F6D2);
  padding-top: 0.2rem;
  padding-bottom: 0.43rem; */
  margin: 0 auto;
  width: 3.32rem;
  height: 5.96rem;
  background-color: #ffffff;
  border: 0.06rem solid #ffda00;
  border-radius: 0.08rem;
  box-sizing: border-box;
}
/* 粽子节 */
.swiper-container {
  /* background-color: rgb(138, 226, 226); */
  z-index: 0;
  width: 100%;
  /* padding-top: 0.2rem;
  padding-bottom: 0.24rem; */
  /* margin-top: 0.2rem;
  margin-bottom: 0.24rem; */
}
/* .swiper-wrapper{
  border
} */
.swiper-slide {
  /* background-position: center; */
  background-size: contain;
  /* width: 100%; */
  width: 3.22rem;
  height: 100%;
  background-color: transparent;
  /* margin-left: -0.01rem; */
  /* margin-left: 0.24rem; */
}
/* .swiper-slide:first-child{
  margin-left: 0.02rem;
  margin-right: 0.12rem;
}
.swiper-slide+.swiper-slide{
  margin-left: 0;
  margin-right: 0.12rem;
} */
.swiper-slide-next,
.swiper-slide-prev {
  /* opacity: 0.5; */
}
.zong_zi_1,
.zong_zi_2,
.zong_zi_3,
.zong_zi_4 {
  background-position: center;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100%;
  /* width: 3.22rem; */
  height: 5.84rem;
}
.swiper-slide {
  transform-style: preserve-3d;
  backface-visibility: hidden;
  /* transition:1s; */
}
.zong_zi_1 {
  background-image: url("../assets/share01.png");
  /* animation: page 1.5s infinite ease-in-out;
  -webkit-animation: page 1.5s 1 ease-in-out forwards; */
}
.zong_zi_2 {
  background-image: url("../assets/share02.png");
}
.zong_zi_3 {
  background-image: url("../assets/share03.png");
}
.zong_zi_4 {
  background-image: url("../assets/share04.png");
}
.emogi_01 {
  position: absolute;
  top: -0.84rem;
  right: -0.23rem;
  width: 1.68rem;
  height: 1.68rem;
  z-index: 9;
}
.emogi_02 {
  position: absolute;
  bottom: -0.52rem;
  left: -0.42rem;
  width: 1.68rem;
  height: 1.68rem;
  z-index: 9;
}
.emogi_03 {
  position: absolute;
  top: 2.02rem;
  left: -0.42rem;
  width: 1.68rem;
  height: 1.68rem;
  z-index: 9;
}
.lineSwiper {
  display: flex;
  align-items: center;
  width: fit-content;
  margin: 0 auto;
  margin-top: 0.12rem;
}
.p1 {
  width: 0.24rem;
  height: 0.04rem;
  border-top-left-radius: 0.02rem;
  border-bottom-left-radius: 0.02rem;
  background-color: rgba(255, 255, 255, 0.4);
}
.p2 {
  width: 0.23rem;
  height: 0.04rem;
  background-color: rgba(255, 255, 255, 0.4);
}
.p3 {
  width: 0.24rem;
  height: 0.04rem;
  border-top-right-radius: 0.02rem;
  border-bottom-right-radius: 0.02rem;
  background-color: rgba(255, 255, 255, 0.4);
}
.pSelect {
  background-color: #ffffff;
}
.footerView {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #9f29e1;
  height: 0.72rem;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
}
.footerView1 {
  background-color: transparent;
}
.clickBtn {
  width: 3.39rem;
  height: 0.53rem;
}
.clickBtn:active {
  filter: brightness(0.9);
}
.rote {
  animation: page 1s 1 ease-in-out;
  /* display: none; */
  -webkit-animation: page 1s 1 ease-in-out forwards;
}
.rote2 {
  animation: page2 1s 1 ease-in-out;
  -webkit-animation: page2 1s 1 ease-in-out forwards;
}
@keyframes page {
  0% {
    transform: rotateY(0deg);
    opacity: 1;
  }
  /* 50% {
      transform: rotateY(-90deg);
      opacity: 0;
    } */
  100% {
    transform: rotateY(-180deg);
    opacity: 0;
  }
}
@keyframes page2 {
  0% {
    transform: rotateY(-180deg);
    opacity: 0;
  }
  /* 0% {
      transform: rotateY(-90deg);
      opacity: 1;
    } */
  100% {
    transform: rotateY(0deg);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tips.vue